export class VaccineStockModel {
  public id: string;
  public name: string;
  public brand: string;
  public adultDose: string;
  public route: string;
  public monthExpectedCover: number;
  public boosterCourse: number;
  public primaryCourse: number;
  public fromAge: number;
  public toAge: number;
  public isDefault: boolean;
  public generalInformation: string;
  public defaultCourse: string = null;
  public defaultCourseName: string;
  public supplierId: string = null;
  public costPrice: number = null;
  public supplierName: string;
  public medicalInformation: string;
  public centreIds: string[];
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/master-data/vaccine-stock.model.ts